import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=6b67c78e&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=6b67c78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67c78e",
  null
  
)

export default component.exports